import React from 'react';
import styled from 'styled-components';
import withStyles from '@mui/styles/withStyles';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import MuiTable from '@mui/material/Table';
import { mixins, fonts } from '../../css';
import { SVGIcon } from '../SVGIcon';

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledSVGIcon = styled(SVGIcon)`
  margin: ${mixins.pxToRem(7)} ${mixins.pxToRem(5)} 0 ${mixins.pxToRem(5)};
`;

export const StyledRow = styled(MuiTableRow)({});

export const StyledCell = withStyles({
  root: {
    paddingRight: 10,
    paddingLeft: 10,
    letterSpacing: 0,
    border: 'none',
    '&:last-child': {
      paddingRight: 10
    }
  },
  body: {
    fontFamily: fonts.fontRegular,
    fontSize: 16
  }
})(MuiTableCell);

const spreadWidthProp = ({ children }) => <MuiTable>{children}</MuiTable>;

export const StyledTable = styled(spreadWidthProp)`
  min-width: ${({ minTableWidth }) => minTableWidth};
`;
